import { render, staticRenderFns } from "./TemplateSummarySpan.vue?vue&type=template&id=13e2777b"
import script from "./TemplateSummarySpan.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateSummarySpan.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports